'use strict';

var chunkFYGG567E_js = require('../chunk-FYGG567E.js');
require('../chunk-3CUP7X6U.js');



Object.defineProperty(exports, "ArrowIcon", {
	enumerable: true,
	get: function () { return chunkFYGG567E_js.a; }
});
